import React, { useContext } from "react";
import "./finalSubmit.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import markimg from "../../assets/Marks.png";
import Total from "../../assets/Total.png";
import TotalQuestion from "../../assets/totalQuestion.png";
import reviewQuestion from "../../assets/review.png";
import examIcon from "../../assets/exam_icon.png";
import percentimg from "../../assets/percent.webp";
import LoadingSpinner from "../common/LoadingSpinner";

import {
  baseServiceUrl,
  finalStatus,
  SubmissionStatusEnum,
  urls
} from "../../environment";
import Confetti from "react-confetti";
import useUserStore from "../../stores/useUserStores";
import useExamStores from "../../stores/useExamStores";

const FinalSubmit = () => {
  const {
    loading,
    exam,
    setuserdetail,
    setislogin,
    setToken,
    examQuestionDetails,
    submissionStateType,
    setSubmissionStateType,
  } = useUserStore();

  const examContext = useExamStores();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Timer state
  const [timeLeft, setTimeLeft] = useState(30);
  const [progress, setProgress] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(true);
  
  useEffect(() => {
    if (["/", "/test/finalresult"].includes(location.pathname)) {
      examContext.setFaceVerified(false);
    }
  }, [location.pathname]);

  // Timer effect
  useEffect(() => {
    if (timeLeft <= 0) {
      // Navigate to login after 30 seconds
      sessionStorage.removeItem("ExamResult");
      setuserdetail(undefined);
      setislogin(false);
      setToken("");
      navigate("/login", { replace: true });
      return;
    }

    const timerId = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
      setProgress(((30 - timeLeft + 1) / 30) * 100);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [timeLeft, navigate, setuserdetail, setislogin, setToken]);

  const [successMessage, setSuccessMessage] = useState<any>(null);
  const [totalNotAnswered, setTotalNotAnswered] = useState<number>(0);
  const [totalAnswered, setTotalAnswered] = useState<number>(0);

  useEffect(() => {
    if (submissionStateType === SubmissionStatusEnum.ILLEGAL) {
      const temp = finalStatus.find(
        (self) => self.status === SubmissionStatusEnum.ILLEGAL
      );
      if (!!temp) setSuccessMessage(temp);
    } else if (submissionStateType === SubmissionStatusEnum.TIME_OUT) {
      const temp = finalStatus.find(
        (self) => self.status === SubmissionStatusEnum.TIME_OUT
      );
      if (!!temp) setSuccessMessage(temp);
    } else {
      const temp = finalStatus.find(
        (self) => self.status === SubmissionStatusEnum.SUBMITTED
      );
      if (!!temp) setSuccessMessage(temp);
    }
  }, [submissionStateType]);

  useEffect(() => {
    if (
      examQuestionDetails &&
      examQuestionDetails?.questions &&
      Array.isArray(examQuestionDetails.questions)
    ) {
      let notAnswered = 0;
      let answered = 0;
      examQuestionDetails.questions.forEach((question: any) => {
        if (!!question.ans_id) {
          answered++;
        } else {
          notAnswered++;
        }
      });
      setTotalAnswered(answered);
      setTotalNotAnswered(notAnswered);
    }
  }, [examQuestionDetails]);

  // Get timer color based on time remaining
  const getTimerColor = () => {
    if (timeLeft <= 10)
      return { bg: "bg-red-500", text: "text-red-600", ring: "ring-red-200" };
    if (timeLeft <= 20)
      return {
        bg: "bg-orange-500",
        text: "text-orange-600",
        ring: "ring-orange-200",
      };
    return {
      bg: "bg-green-500",
      text: "text-green-600",
      ring: "ring-green-200",
    };
  };

  const timerColors = getTimerColor();
  const progressPercentage = ((30 - timeLeft) / 30) * 100;

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <section
            id="final submit"
            className="z-50 flex flex-col text-sm md:justify-between md:overflow-x-scroll md:overflow-x-hidden md:flex-col"
          >
            <header className="">
              <nav className="relative mt-2 mx-2 md:mt-6 w-full  px-4 py-3 md:flex md:items-center md:justify-between md:px-6 md:py-0 lg:px-8 xl:mx-auto  ">
                <Link to="/" replace>
                  <button
                    type="button"
                    className="w-full sm:w-auto flex items-center justify-center px-6 py-2 text-base font-medium text-gray-700 hover:bg-gray-800 hover:text-white transition-all duration-300 bg-white border rounded-lg gap-x-2 whitespace-nowrap hover:scale-105 active:scale-95"
                    onClick={() => {
                      sessionStorage.removeItem("ExamResult");
                      setuserdetail(undefined);
                      setislogin(false);
                      setToken("");
                    }}
                  >
                    <svg
                      className="w-5 h-5 rtl:rotate-180 transition-transform duration-300 group-hover:translate-x-1"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                      />
                    </svg>
                    <span>Go to Home</span>
                  </button>
                </Link>

                {/* Modern Timer Display */}
                <div className="flex items-center gap-4 ml-auto  ">
                  <div className="flex items-center gap-3  px-4 py-2 ">
                    {/* Animated Timer Circle */}
                    <div className="relative">
                      <div
                        className={`w-16 h-16 rounded-full ${timerColors.ring} ring-4 ring-opacity-30 flex items-center justify-center relative overflow-hidden`}
                      >
                        {/* Background Circle */}
                        <div className="absolute inset-0 rounded-full bg-gray-100"></div>

                        {/* Progress Circle */}
                        <div
                          className={`absolute inset-0 rounded-full ${timerColors.bg} transition-all duration-1000 ease-out`}
                          style={{
                            background: `conic-gradient(${timerColors.bg.replace(
                              "bg-",
                              ""
                            )} ${
                              progressPercentage * 3.6
                            }deg, transparent 0deg)`,
                          }}
                        ></div>

                        {/* Timer Content */}
                        <div className="relative z-10 flex flex-col items-center justify-center bg-white rounded-full w-12 h-12 shadow-sm">
                          <span
                            className={`text-lg font-bold ${timerColors.text} transition-colors duration-300`}
                          >
                            {timeLeft}
                          </span>
                          <span className="text-xs text-gray-500 -mt-1">
                            sec
                          </span>
                        </div>

                        {/* Pulse Animation for Low Time */}
                        {timeLeft <= 10 && (
                          <div className="absolute inset-0 rounded-full bg-red-400 animate-ping opacity-20"></div>
                        )}
                      </div>

                      {/* Floating Dots Animation */}
                      <div className="absolute -top-1 -right-1">
                        <div
                          className={`w-3 h-3 ${timerColors.bg} rounded-full animate-bounce`}
                        ></div>
                      </div>
                      <div className="absolute -bottom-1 -left-1">
                        <div
                          className={`w-2 h-2 ${timerColors.bg} rounded-full animate-bounce`}
                          style={{ animationDelay: "0.5s" }}
                        ></div>
                      </div>
                    </div>

                    {/* Timer Text */}
                    <div className="flex flex-col">
                      <span className="text-lg font-semibold text-gray-800">
                        Auto Redirect
                      </span>
                      <span className="text-sm text-gray-500">
                        Redirecting to login...
                      </span>

                      {/* Progress Bar */}
                      <div className="w-24 h-1 bg-gray-200 rounded-full mt-1 overflow-hidden">
                        <div
                          className={`h-full ${timerColors.bg} transition-all duration-1000 ease-out rounded-full`}
                          style={{ width: `${progressPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </header>

            <div className=" flex flex-col animate-fade-in">
              <div className="w-full flex justify-center items-center">
                <h1 className="font-semibold text-xl md:text-4xl text-blue-500 animate-slide-up">
                  {successMessage ? successMessage.title : "N/A"}
                </h1>
              </div>
              <div className="w-11/12 sm:w-9/12 xl:w-6/12 mx-auto">
                <h3
                  className={`mt-2 font-semibold animate-slide-up ${
                    submissionStateType === SubmissionStatusEnum.SUBMITTED
                      ? `text-center text-lg`
                      : `text-base`
                  }`}
                  style={{ animationDelay: "0.2s" }}
                >
                  {successMessage ? successMessage.subtitle : "N/A"}
                </h3>
              </div>
            </div>

            <div className="w-[97%] md:mx-6 my-3 md:my-2 mx-auto gap-5 grid grid-cols-12 lg:mt-[20px]">
              <div className="col-span-12 flex rounded-xl border shadow-sm bg-[#F8FAFB] h-[135px] md:h-[150px] p-3 hover:bg-[#FFF2F8] transition-all duration-300 transform hover:scale-105 hover:shadow-lg animate-slide-up">
                <div className="w-full flex items-center justify-center">
                  <div className="text-center w-full">
                    <h3 className="md:text-3xl text-2xl font-medium text-gray-800 md:mt-2">
                      {!!exam ? exam.title : "N/A"}
                    </h3>
                    <p className="md:text-xl text-md font-medium text-gray-500 font-bold mt-2">
                      {!!exam ? exam.exam_group_title : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-span-6 flex rounded-xl border shadow-sm bg-[#F8FAFB] h-[135px] md:h-[150px] p-6 hover:bg-[#FFF2F8] transition-all duration-300 transform hover:scale-105 hover:shadow-lg animate-slide-up"
                style={{ animationDelay: "0.1s" }}
              >
                <div className="w-full flex flex-col items-center">
                  <div className="flex items-center justify-center gap-x-2">
                    <img
                      src={TotalQuestion}
                      className="w-10 h-10 mr-4 transition-transform duration-300 hover:scale-110"
                      alt="Total Questions"
                    />
                    <p className="md:text-xl text-sm uppercase tracking-wide text-gray-800">
                      Total Question
                    </p>
                  </div>
                  <div className="mt-2 text-center w-full">
                    <h3 className="md:text-3xl text-2xl font-medium text-gray-800 mt-2">
                      {!!exam ? exam.total_questions : "N/A"}
                    </h3>
                  </div>
                </div>
              </div>
              <div
                className="col-span-6 flex rounded-xl border shadow-sm bg-[#F8FAFB] h-[135px] md:h-[150px] p-6 hover:bg-[#f4ece4] transition-all duration-300 transform hover:scale-105 hover:shadow-lg animate-slide-up"
                style={{ animationDelay: "0.2s" }}
              >
                <div className="w-full flex flex-col items-center">
                  <div className="flex items-center justify-center gap-x-2">
                    <img
                      src={percentimg}
                      className="w-10 h-10 mr-4 transition-transform duration-300 hover:scale-110"
                      alt="Total Marks"
                    />
                    <p className="md:text-xl text-sm uppercase tracking-wide text-gray-800">
                      Total Marks
                    </p>
                  </div>
                  <div className="mt-2 text-center w-full">
                    <h3 className="md:text-3xl text-2xl font-medium text-gray-800 mt-2">
                      {!!exam ? exam.total_marks : "N/A"}
                    </h3>
                  </div>
                </div>
              </div>
              <div
                className="col-span-6 flex rounded-xl border shadow-sm bg-[#F8FAFB] h-[135px] md:h-[150px] p-6 hover:bg-[#F0F8FB] transition-all duration-300 transform hover:scale-105 hover:shadow-lg animate-slide-up"
                style={{ animationDelay: "0.3s" }}
              >
                <div className="w-full flex flex-col items-center">
                  <div className="flex items-center justify-center gap-x-2">
                    <img
                      src={markimg}
                      className="w-10 h-10 mr-4 transition-transform duration-300 hover:scale-110"
                      alt="Attempted Questions"
                    />
                    <p className="md:text-xl text-sm uppercase tracking-wide text-gray-800">
                      No. of Attempted
                    </p>
                  </div>
                  <div className="mt-2 text-center w-full">
                    <h3 className="md:text-3xl text-2xl font-medium text-gray-800 mt-2">
                      {totalAnswered}
                    </h3>
                  </div>
                </div>
              </div>

              <div
                className="col-span-6 flex rounded-xl border shadow-sm bg-[#F8FAFB] h-[135px] md:h-[150px] p-6 hover:bg-[#f4ece4] transition-all duration-300 transform hover:scale-105 hover:shadow-lg animate-slide-up"
                style={{ animationDelay: "0.4s" }}
              >
                <div className="w-full flex flex-col items-center">
                  <div className="flex items-center justify-center gap-x-2">
                    <img
                      src={reviewQuestion}
                      className="w-10 h-10 mr-4 transition-transform duration-300 hover:scale-110"
                      alt="Not Attempted Questions"
                    />
                    <p className="md:text-xl text-sm uppercase tracking-wide text-gray-800">
                      No. of Not Attempted
                    </p>
                  </div>
                  <div className="mt-2 text-center w-full">
                    <h3 className="md:text-3xl text-2xl font-medium text-gray-800 mt-2">
                      {totalNotAnswered}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default FinalSubmit;